import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function ButtonsPlaceholder() {
  return (
    <Component>
      <MainButton />
      <SecondButtonsWrapper>
        <SecondButton />
        <SecondButton />
      </SecondButtonsWrapper>
    </Component>
  );
}

export default ButtonsPlaceholder;

const Component = styled.div`
  margin-top: 30px;

  ${media.laptopOnly(css`
    margin-top: 25px;
  `)}

  ${media.mobile(css`
    margin-top: 25px;
  `)}
`;

const MainButton = styled.div`
  width: 100%;
  height: 41.55px;
  border-radius: 30px;
  ${placeholderAnimationCss}
`;

const SecondButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.mobile(css`
    display: block;
  `)}
`;

const SecondButton = styled.div`
  width: 48%;
  height: 41.55px;
  border-radius: 30px;
  margin-top: 10px;
  ${placeholderAnimationCss}

  ${media.mobile(css`
    width: 100%;
  `)}
`;
